<template>
  <div>
    <v-datetime-picker
      v-model="internalValue"
      date-format="dd.MM.yyyy"
      :time-picker-props="timeProps"
      :label="label"
      :disabled="disabled"
      :text-field-props="textFieldProps"
      time-format="HH:mm"
    >
      <template slot="dateIcon">
        <v-icon>mdi-calendar</v-icon>
      </template>
      <template slot="timeIcon">
        <v-icon>mdi-clock</v-icon>
      </template>
      <template slot="actions" slot-scope="{ parent }">
        <v-btn color="" @click.native="parent.clearHandler">Zurücksetzen</v-btn>
        <v-btn color="primary" @click="parent.okHandler">OK</v-btn>
      </template>
    </v-datetime-picker>
  </div>
</template>

<script>
export default {
  name: "DateTimePicker",
  mixins: [],
  components: {},
  props: {
    value: {
      type: Date,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      internalValue: null,
      timeProps: {
        format: "24hr"
      }
    };
  },
  computed: {
    textFieldProps: function() {
      return {
        appendIcon: 'mdi-calendar'
      }
    }
  },
  watch: {
    value: function(val) {
      this.internalValue = val;
    },
    internalValue: function(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.internalValue = this.value;
  },
  methods: {
  },
};
</script>
<style scoped>
</style>